import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'react-toastify/dist/ReactToastify.css';
import * as appointmentActions from '../../actions/appointmentActions';
import { Document, Page, pdfjs } from "react-pdf";
 pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
// import { Page } from 'react-pdf';
// import { Document } from 'react-pdf/dist/entry.webpack';
import * as constant from '../../constants/constant';
import './pdf.css'
import {
	Modal,
} from 'react-bootstrap';

class PdfViewerComponent extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			numPages: null,
			pageNumber: 1,
		};
		this.onDocumentLoad = this.onDocumentLoad.bind(this)
	}

	onDocumentLoad({numPages}) {
		console.log("==>>")
		this.setState({ 'numPages': numPages/* .pdfInfo.numPages */ });
	}


	render() {
		const { pageNumber, numPages } = this.state;
		var pdfurl = this.props.pdfurl;
		return (
			
			<Modal show={this.props.openModal} size="modal-lg"  onHide={this.props.hidePdfViewerModal}>
				<Modal.Header>
					{/* <ModalClose onClick={this.props.hidePdfViewerModal} /> */}
				</Modal.Header>
				<Modal.Body className="myAppPopUp">
					<div className="xyz" style={{ 'overflow': 'auto', 'minHeight': '300px'}}>
						<Document
							file={pdfurl}
							onLoadSuccess={this.onDocumentLoad}
							onLoadError={(e) => console.error("eeee", e)}
							width={100}
						>
							{/* <Page pageNumber={pageNumber} /> */}
							{
								Array.from(
									new Array(numPages),
									(el, index) => (
										<Page
											key={`page_${index + 1}`}
											pageNumber={index + 1}
										/>
									),
								)
							}
						</Document>
						{/* <p>Page {pageNumber} of {numPages}</p> */}
					</div>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
		);
		
	}
}
function mapStateToProps(state, ownProps) {
	return {
		signin: state.signin
	};
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(appointmentActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(PdfViewerComponent);
